import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Building2, Users, ShoppingCart, TrendingUp, DollarSign } from "lucide-react";
import { StatCard } from "./StatCard";

export function OverviewTab({ overview }) {
  if (!overview) return null;

  return (
    <div className="space-y-6">
      <div className="grid grid-cols-2 md:grid-cols-4 gap-3">
        <StatCard label="Restaurantes" value={overview.total_restaurants} icon={Building2} />
        <StatCard label="Usuarios" value={overview.total_users} icon={Users} />
        <StatCard label="Pedidos totais" value={overview.total_orders?.toLocaleString()} icon={ShoppingCart} />
        <StatCard label="Novos este mes" value={overview.new_restaurants_month} sub="restaurantes" icon={TrendingUp} />
      </div>

      <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
        <Card className="bg-emerald-50 border-emerald-200">
          <CardContent className="p-4 text-center">
            <p className="text-3xl font-black text-emerald-700">{overview.mrr_estimate?.toLocaleString()} EUR</p>
            <p className="text-xs text-emerald-600 font-medium">MRR Estimado</p>
          </CardContent>
        </Card>
        <Card className="bg-blue-50 border-blue-200">
          <CardContent className="p-4 text-center">
            <p className="text-3xl font-black text-blue-700">{overview.arr_estimate?.toLocaleString()} EUR</p>
            <p className="text-xs text-blue-600 font-medium">ARR Estimado</p>
          </CardContent>
        </Card>
        <Card className="bg-amber-50 border-amber-200">
          <CardContent className="p-4 text-center">
            <p className="text-3xl font-black text-amber-700">{overview.total_commissions?.toFixed(2)} EUR</p>
            <p className="text-xs text-amber-600 font-medium">Comissoes Afiliados</p>
          </CardContent>
        </Card>
      </div>

      <div className="grid grid-cols-3 gap-3">
        <Card><CardContent className="p-4 text-center">
          <p className="text-2xl font-bold text-emerald-600">{overview.restaurants_active}</p>
          <p className="text-xs text-muted-foreground">Ativos</p>
        </CardContent></Card>
        <Card><CardContent className="p-4 text-center">
          <p className="text-2xl font-bold text-amber-600">{overview.restaurants_trial}</p>
          <p className="text-xs text-muted-foreground">Trial</p>
        </CardContent></Card>
        <Card><CardContent className="p-4 text-center">
          <p className="text-2xl font-bold text-red-600">{overview.restaurants_suspended}</p>
          <p className="text-xs text-muted-foreground">Suspensos</p>
        </CardContent></Card>
      </div>

      <Card>
        <CardHeader><CardTitle className="text-sm">Resumo de Afiliados</CardTitle></CardHeader>
        <CardContent className="grid grid-cols-3 gap-4 text-center">
          <div>
            <p className="text-xl font-bold">{overview.total_affiliates}</p>
            <p className="text-xs text-muted-foreground">Afiliados</p>
          </div>
          <div>
            <p className="text-xl font-bold">{overview.total_referrals}</p>
            <p className="text-xs text-muted-foreground">Indicacoes</p>
          </div>
          <div>
            <p className="text-xl font-bold">{overview.total_commissions?.toFixed(2)} EUR</p>
            <p className="text-xs text-muted-foreground">Comissoes totais</p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
